/**
 * Implements the child-grid link behavior of RVC DataTables
 */

import Marionette from "backbone.marionette";

import ReportModel from "../../models/report";
import DatatableLinkModel from "../../models/datatable-link";
import StaticTable from "../../views/datatable/static-table";
import AjaxLoader from "../../views/generic/ajax-loader";
import { decodeData, errorParser } from "../../utils";

class ChildGridLink extends Marionette.Behavior {
  ui() {
    return {
      link: "a.child-grid",
    };
  }

  events() {
    return {
      // debounces clicks on link
      "click @ui.link": _.debounce(this._handleClick, 400, true),
    };
  }

  initialize() {
    this.loader = new AjaxLoader().render().el;
  }

  _handleClick(e) {
    e.preventDefault();

    // get jQuery reference to wrapping table row
    const tr = $(e.currentTarget).closest("tr");
    // get DT reference to clicked row
    const row = this.view.dt.row(tr);

    // extract link data
    const linkData = $(e.currentTarget).data();
    const linkModel = new DatatableLinkModel({
      type: linkData.type,
      endpoint: decodeData(linkData.url),
      data: JSON.parse(decodeData(linkData.params)),
    });

    // does row have a child content node?
    if (row.child.isShown()) {
      // close it
      row.child.hide();
      tr.removeClass("active-child");
    } else {
      // set cell as selected
      tr.addClass("active-child");

      // show loader
      row.child(this.loader).show();
      tr.next().addClass("active-child");

      if ("main" === linkModel.getType()) {
        // render to main screen
        console.warn(
          "This link should open on main screen",
          linkModel.toJSON()
        );
      } else {
        // generate child grid
        this._getChildGrid(linkModel, this._onChildGridReady, row, tr);
      }
    }
  }

  _getChildGrid(linkModel, callback, row, tr) {
    const URL = `${linkModel.getUrl()}`;
    const params = "draw=1&start=0&length=200";
    const separator = URL.indexOf("?") > -1 ? "&" : "?";

    // configure report model
    const Model = ReportModel.extend({
      // hack the endpoint to request up to 100 rows of data, otherwise
      // pagination will kick in and only 10 rows will be returned and
      // this component is not paginated.
      urlRoot: `${URL}${separator}${params}`,
    });

    // instantiate it, listen for changes and go fetch
    new Model()
      .on("change", function (model) {
        // on success, pass the model along with
        // the row and tr to the callback
        callback.apply(this, [model, row, tr]);
      })
      .on("error", function (model, response) {
        // surface response.status
        const errorMessage = errorParser(response);
        model.setError(errorMessage);
      })
      .fetch();
  }

  _onChildGridReady(model, row, tr) {
    // assume no results
    let markup = "No data found";

    // display error when it occurs
    const errorMessage = model.get("error");
    if (!_.isEmpty(errorMessage)) {
      markup = errorMessage;
    } else if (model.get("recordsTotal") > 0) {
      // render a static table
      const content = new StaticTable({
        model,
      }).render();
      markup = content.el;
    }

    // show content
    row.child(markup).show();
    tr.next().addClass("active-child");
  }
}

export { ChildGridLink as default };
